import { useInitPlanPrivilege } from '@shared/hooks/use-init-plan-privilege';
import { useInitRolePrivilege } from '@shared/hooks/use-init-role-privilege';
import { PropsWithChildren } from 'react';
import '@/styles/loader.css';

export const RolePrivilegeWrapper = ({ children }: PropsWithChildren) => {
  const { fetchingRolePrivileges } = useInitRolePrivilege(); // initialize the role privileges
  const { fetchingPlanPrivileges } = useInitPlanPrivilege(); // initialize the plan privileges

  if (fetchingRolePrivileges || fetchingPlanPrivileges) {
    // min-h-screen is used to overlap the google recaptcha provider ui after login
    return (
      <div className="w-full min-h-dvh grid place-items-center">
        <div className="page-loader"></div>
      </div>
    );
  }

  return children;
};
